import { useContext } from 'react'
import { VerticalUIContext } from './VerticalUIProvider'
import { VerticalUIContextValue } from './types'
import { GENERIC_VERTICAL_PROFILE } from './registry'

const DEFAULT_FALLBACK_VALUE: VerticalUIContextValue = {
  slug: 'otro',
  profile: GENERIC_VERTICAL_PROFILE,
  loading: false,
}

/**
 * Hook para acceder a la configuración del vertical activo en el frontend.
 * Si se llama fuera de VerticalUIProvider (ej. páginas públicas o tests aislados),
 * devuelve de forma segura el perfil 'otro' (genérico) sin lanzar error.
 */
export function useVerticalUI(): VerticalUIContextValue {
  const context = useContext(VerticalUIContext)
  return context || DEFAULT_FALLBACK_VALUE
}
